/**
 * @param {unknown} thing
 * @returns {boolean}
 */
export function whitespace(thing) {
  /** @type {string} */
  var value = // @ts-ignore looks like a node.
  thing && typeof thing === 'object' && thing.type === 'text' ? // @ts-ignore looks like a text.
  thing.value || '' : thing; // HTML whitespace expression.
  // See <https://html.spec.whatwg.org/#space-character>.

  return typeof value === 'string' && value.replace(/[ \t\n\f\r]/g, '') === '';
}